/**
 * Bottom CTA — Oatmeal CallToActionSimpleCentered driving the existing
 * #topbar-talk modal trigger that `wirePilotModals()` (lib/pilot/
 * modals.js) binds to the talk-modal flow at boot.
 */

import React from 'react';
import {clsx} from 'clsx/lite';
import {CallToActionSimpleCentered} from '../../oatmeal/sections/call-to-action-simple-centered';
import {Button} from '../../oatmeal/elements/button';
import {trackEvent} from '../../lib/pilotTracking';
import {usePilot} from './PilotContext';

export default function PilotBottomCTA() {
  const {viewMode} = usePilot();
  // F17 Slice D: was hidden in pitch/demo/vision modes by
  // `body.X-mode .mp-bottom-cta` CSS rules. Now React-state driven.
  const isStoryMode = viewMode === 'story' || viewMode === 'sandbox';
  const handleClick = () => {
    trackEvent('cta_click', {label: 'bottom_talk_to_us'});
    const trigger = document.querySelector('#topbar-talk') as HTMLButtonElement | null;
    if (trigger) {
      trigger.click();
      return;
    }
    const backdrop = document.querySelector('#talk-modal');
    if (backdrop) backdrop.classList.add('open');
  };

  return (
    <CallToActionSimpleCentered
      className={clsx(
        'mp-bottom-cta border-t border-taupe-200 dark:border-taupe-800',
        !isStoryMode && 'hidden',
      )}
      headline="Ready to see your operations?"
      subheadline={
        <p>
          A 30-minute working session with the founders &mdash; no demo. We
          bring a live read of the operations you already know are broken.
        </p>
      }
      cta={
        <Button
          className="mp-bottom-cta-btn"
          onClick={handleClick}
          size="lg"
        >
          Talk to us to learn more
          <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
            <polygon points="6,3 11,8 6,13" />
          </svg>
        </Button>
      }
    />
  );
}
